<div class="wiz-file">
  <!-- file-select -->
  <ng-content></ng-content>

  <!-- wiz-file-uploading : model has a name but no id yet-->
  <ng-container *ngIf="model.name && !model.id">
    <div class="wiz-file-upload__percentage">{{ uploadPercentage }} %</div>

    <app-dots-loader class="wiz-file-upload__loader"></app-dots-loader>

    <div class="wiz-file-upload__label" i18n>Téléchargement en cours...</div>
    <div class="wiz-file-upload__filename">{{ model?.name }}</div>
  </ng-container>

  <!-- file-rendered : model has a name and have been given an id -->
  <ng-container *ngIf="model.id">
    <div
      class="wiz-file__preview"
      [class.wiz-file__preview--placeholder]="!src"
      [attr.aria-label]="'Votre CV ' + model?.name"
      i18n-attr.aria-label
    >
      <app-dots-loader *ngIf="src && !loaded" class="wiz-file__loader"></app-dots-loader>

      <img
        *ngIf="src"
        class="wiz-file__image"
        [src]="src"
        alt="prévisualisation du fichier uploadé"
        (error)="handleError()"
        (load)="handleLoad()"
        i18n-alt
      />
      <svg
        *ngIf="!src"
        class="wiz-file__svg"
        width="11em"
        height="15.625em"
        viewBox="0 0 175 250"
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        role="presentation"
      >
        <path
          d="M28.26 22h17.48c3.57 0 4.86.37 6.17 1.07 1.3.7 2.32 1.72 3.02 3.02.7 1.3 1.07 2.6 1.07 6.17v17.48c0 3.57-.37 4.86-1.07 6.17a7.27 7.27 0 0 1-3.02 3.02c-1.3.7-2.6 1.07-6.16 1.07h-17.5c-3.56 0-4.85-.37-6.16-1.07a7.27 7.27 0 0 1-3.02-3.02c-.7-1.3-1.07-2.6-1.07-6.17V32.26c0-3.57.37-4.86 1.07-6.17a7.27 7.27 0 0 1 3.02-3.02c1.3-.7 2.6-1.07 6.17-1.07zM71.02 22h80.96c1.65 0 2.32.19 2.97.53.65.35 1.17.86 1.52 1.52.34.65.53 1.32.53 2.97v1.96c0 1.65-.19 2.32-.53 2.97a3.63 3.63 0 0 1-1.52 1.52c-.65.34-1.32.53-2.97.53H71.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM71.02 48h80.96c1.65 0 2.32.19 2.97.53.65.35 1.17.86 1.52 1.52.34.65.53 1.32.53 2.97v1.96c0 1.65-.19 2.32-.53 2.97a3.63 3.63 0 0 1-1.52 1.52c-.65.34-1.32.53-2.97.53H71.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM23.02 85h128.96c1.65 0 2.32.19 2.97.53.65.35 1.16.86 1.51 1.52.35.65.54 1.32.54 2.97v1.96c0 1.65-.19 2.32-.54 2.97a3.63 3.63 0 0 1-1.51 1.52c-.65.34-1.32.53-2.97.53H23.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM23.02 113h128.96c1.65 0 2.32.19 2.97.53.65.35 1.16.86 1.51 1.52.35.65.54 1.32.54 2.97v1.96c0 1.65-.19 2.32-.54 2.97a3.63 3.63 0 0 1-1.51 1.52c-.65.34-1.32.53-2.97.53H23.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM23.02 141h128.96c1.65 0 2.32.19 2.97.53.65.35 1.16.86 1.51 1.52.35.65.54 1.32.54 2.97v1.96c0 1.65-.19 2.32-.54 2.97a3.63 3.63 0 0 1-1.51 1.52c-.65.34-1.32.53-2.97.53H23.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM23.02 169h128.96c1.65 0 2.32.19 2.97.53.65.35 1.16.86 1.51 1.52.35.65.54 1.32.54 2.97v1.96c0 1.65-.19 2.32-.54 2.97a3.63 3.63 0 0 1-1.51 1.52c-.65.34-1.32.53-2.97.53H23.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53zM23.02 197h58.96c1.65 0 2.32.19 2.97.53.65.35 1.17.86 1.52 1.52.34.65.53 1.32.53 2.97v1.96c0 1.65-.19 2.32-.53 2.97a3.63 3.63 0 0 1-1.52 1.52c-.65.34-1.32.53-2.97.53H23.02c-1.65 0-2.32-.19-2.97-.53a3.63 3.63 0 0 1-1.52-1.52c-.34-.65-.53-1.32-.53-2.97v-1.96c0-1.65.19-2.32.53-2.97.35-.66.86-1.17 1.52-1.52.65-.34 1.32-.53 2.97-.53z"
        />
      </svg>
    </div>

    <div *ngIf="uploadCompleted" class="wiz-file__overlay">
      <div class="wiz-file__circle">
        <div class="wiz-file__checkmark"></div>
      </div>

      <p class="wiz-file__confirm-text" i18n>Le document a bien été chargé&nbsp;!</p>
    </div>
  </ng-container>
</div>
<input
  *ngIf="editable; else displayName"
  class="wiz-file-name-input"
  type="text"
  aria-label="Éditer le nom du fichier"
  i18n-aria-label
  [(ngModel)]="modelName"
  [class.wiz-file-name-input--transparent-placeholder]="!model.id"
  [disabled]="!model.id"
/>

<ng-template #displayName>
  <p *ngIf="model?.id" class="wiz-file-name-display">{{ model?.name }}</p>
</ng-template>
